import React from "react";
import {message} from 'antd';

/**
 * Constant indicating types for EngageMessage
 * @type {
 *     success: string,
 *     info: string,
 *     warn: string,
 *     error: string
 * }
 */
const messageType = {
    success: 'success',
    info: 'info',
    warn: 'warning',
    error: 'error',
};

/**
 * Displays any warnings and errors as messages
 * @param response
 * @param messageType
 */
const showMessages = (response, messageType = null) => {
    const duration = 5;

    // Single message string
    if (typeof response === 'string' && messageType !== null) {
        message[messageType](response, duration);
    }

    // Multiple messages within the response object
    if (typeof response === 'object') {
        if (response.warnings) {
            response.warnings.map((warning) => {
                return message.warning(warning, duration);
            });
        }

        if (response.successes) {
            response.successes.map((success) => {
                return message.success(success, duration);
            });
        }

        if (response.infos) {
            response.infos.map((info) => {
                return message.info(info, duration);
            });
        }

        if (response.errors) {
            response.errors.map((error) => {
                return message.error(error, duration);
            });
        }
    }
};

const getMemberMessages = () => {
    const forgotPasswordURL = window.env.BACKEND_WEB_URL + '/password/reset';
    const rcsContactURL = 'https://reginacarshare.wordpress.com/contact/';
    const cartogoContactURL = 'https://www.aspen.gov/221/Car-To-Go';

    return ({
        regina: [
            {
                type: 'warning',
                message: 'Did you know we recently changed our system?',
                description: <span>
                    For security purposes, we kindly ask all users of our new system to reset your password via the <a
                    href={forgotPasswordURL} target="_blank" rel="noopener noreferrer">forgot password</a> link. Please ignore this message once you have reset your password. Thank you for your understanding.
                </span>,
            },
            {
                type: 'warning',
                message: 'Don’t have a registered email address?',
                description: <span>
                    Please <a href={rcsContactURL} target="_blank" rel="noopener noreferrer">contact us</a> for assistance.
                </span>,
            },
        ],
        cartogo: [
            {
                type: 'warning',
                message: 'Did you know we recently changed our system?',
                description: <span>
                    For security purposes, we kindly ask all users of our new system to reset your password via the <a
                    href={forgotPasswordURL} target="_blank" rel="noopener noreferrer">forgot password</a> link. Please ignore this message once you have reset your password. Thank you for your understanding.
                </span>,
            },
            {
                type: 'warning',
                message: 'Don’t have a registered email address?',
                description: <span>
                    Please <a href={cartogoContactURL} target="_blank" rel="noopener noreferrer">contact us</a> for assistance.
                </span>,
            },
        ]
    })
};

export {messageType, showMessages, getMemberMessages};
